import React, { useEffect, useRef, useState } from 'react';

import './popover.scss';
import { getModalPosition, isClickedOutside } from '../../../infrastructure/utils/popover.utils';
import { DEFAULT_ALIGN, DEFAULT_PADDING, DEFAULT_POSITION } from '../../../constants/options-button.constants';
import { CloseIcon } from '../icons/icons';

export type PopoverPosition = 'top' | 'bottom' | 'left' | 'right' | 'center';
export type PopoverAlign = 'start' | 'end' | 'center';

export interface PopoverProps {
    buttonRef: React.MutableRefObject<HTMLElement>;
    children: React.ReactNode;
    isOpen: boolean;
    position?: PopoverPosition;
    align?: PopoverAlign;
    padding?: number;
    customWidth?: number;
    onClickOutside?: (event) => void;
    onClose?: (e) => void;
    withCloseIcon?: boolean;
    customLeft?: number;
    customTop?: number | string;
    autoFlip?: boolean;
}

const Popover = (props: PopoverProps) => {
    const [modalPosition, setModalPosition] = useState(null);
    const modalRef = useRef(null);

    const {
        children,
        buttonRef,
        isOpen,
        position = DEFAULT_POSITION,
        align = DEFAULT_ALIGN,
        padding = DEFAULT_PADDING,
        customWidth,
        onClickOutside,
        onClose,
        withCloseIcon,
        customLeft,
        customTop,
        autoFlip = false,
    } = props;

    const handleClickOutside = (event: MouseEvent) => {
        if (isClickedOutside(modalRef, buttonRef, event)) {
            onClickOutside(event);
        }
    };

    useEffect(() => {
        const currentPosition =
            getModalPosition(position, align, padding, buttonRef.current, modalRef.current, autoFlip);
        setModalPosition(currentPosition);
        if (isOpen && onClickOutside) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return isOpen ? (
        <div
            ref={modalRef}
            className='popover__modal'
            style={{
                top: customTop !== undefined ? customTop : modalPosition?.top || 0,
                left: customLeft !== undefined ? customLeft : modalPosition?.left || 0,
                opacity: modalPosition ? 1 : 0,
                width: customWidth
            }}
        >
            {withCloseIcon &&
            <div className='popover__modal--icon'>
                <CloseIcon onClick={e => onClose(e)}/>
            </div>}
            { children}
        </div>
    ) : null;
};

export { Popover };


